import React from 'react'
import config from 'config'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'

export default function Spinner({ isWhite, customCss }) {
  return (
    <p className={`${isWhite ? styles.loaderWhite : styles.loader} ${customCss}`}>
      {/* <Icon name='spinner' size='large24' styleModifier={styles.rotationAnimation} /> */}
      <img className={styles.loader} src={`${config.assetUrl}/images/loaderFinal.gif`} alt='loading' />
    </p>
  )
}
